import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { PageType, PosBoardInfoType } from '@kinderlabs-pos/shared-data-type';

export const getPosBoardInfoListAsync =
	(rootUrl: string) =>
	async ({ storeId }: { storeId: number }) =>
		(
			await posAxiosClient.get<PageType<PosBoardInfoType>>(`${rootUrl}/pos-board/list`, {
				params: {
					storeId: storeId,
				},
			})
		).data;
